import React, { Component, Suspense } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
// import LoginView from "./../custom_modules/user_management/LoginView.jsx";
// import Newpwdgenetration from "./../custom_modules/user_management/Newpwdgenetration.jsx";
// import NewRegistration from "./../custom_modules/user_management/NewRegistration.jsx";
import { withTranslation, setLanguage, getLanguage } from "react-multi-lang";
import { withAlert } from "react-alert";
import {
  Servicecalls, CF_decrypt, convertUTCDateToLocalDate, GetutcDate, Silentauditobject,
  Serviceuserworkflowdetails, Serviceprojectdetails, Serviceforusersettings, Serviceforserverdateformat,
  onAuditHandler, getCurrentDateAndTimeOnBackend
} from "./../custom_functions/Functions.jsx";
import $ from "jquery";
import "bootstrap";
import store from "./../redux_store/store/index";
import { replacestate, updatecontrolrights } from "./../redux_store/actions/index";
import {
  defalutreduxState,
  isMultitenant,
  isReportEnabled,
  releaseVersion,
} from "./../custom_functions/Constance.jsx";
import Service from "./general/Service.jsx";
import 'owl.carousel/dist/assets/owl.carousel.css'; // Import Owl Carousel CSS
import 'owl.carousel/dist/assets/owl.theme.default.css'; // Import Owl Carousel default theme CSS
const OwlCarousel = React.lazy(() => import('react-owl-carousel')); // Import React Owl Carousel
const SelectBox = React.lazy(() => import("./../controls/SelectBox.jsx"));


const Tenantselection = React.lazy(() =>
  import("./user_management/modules/Tenantselection.jsx")
);
const TenantRegistration = React.lazy(() =>
  import("./user_management/modules/TenantRegistration.jsx")
);
const LoginView = React.lazy(() =>
  import("./../custom_modules/user_management/modules/LoginView.jsx")
);
const Newpwdgenetration = React.lazy(() =>
  import("./../custom_modules/user_management/modules/Newpwdgenetration.jsx")
);

const FreeUserLogin = React.lazy(() =>
  import("./../custom_modules/user_management/modules/FreeUserLogin.jsx")
);
// const NewRegistration = React.lazy(() => import('./../custom_modules/user_management/NewRegistration.jsx'));

class Login extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.ELNurl = window.appUrl.ELN;
    this.state = {
      redirect: false,
      DomainData: [],
      DomainCode: "",
      DomainCategory: "",
      DomainCodeValidcls: "",
      CurrentView: isMultitenant === 1 ? 3 : 0,
      // CurrentView: 0,
      sitecode: "",
      username: "",
      siteobj: "",
      iscreated: false,
      passwordstatus: "",
      Userobj: "",
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
      ServcieProcessbar: false,
      ServiceTenant: "MAIN",
      hashtenant: "",
      currenttenant: "MAIN",
      //isDropdownOpen: false,
      LanguageData: [
        // isMultitenant == 2 ? {
        //  sLanguageName: "Select Language",
        //  sLanguageCode: "en",
        // } : {},
        {
          sLanguageName: "English",
          sLanguageCode: "en",
        },
        {
          sLanguageName: "Korean",
          sLanguageCode: "ko",
        },
        {
          sLanguageName: "French",
          sLanguageCode: "fr",
        },
        {
          sLanguageName: "German",
          sLanguageCode: "de",
        },
      ],
    };

    this.previouskey = "";
  }

  async componentDidMount() {
    document.title = this.props.t("ELNTitle.IDS_LBL_LOGIN");
    console.log("mount");
    this._isMounted = true;
    if ($.session.get("User") && (sessionStorage.getItem("_OrderView") === undefined || sessionStorage.getItem("_OrderView") === null)) {
      let passobject = {
        usercode: sessionStorage.getItem("User"),
        activeusercode: sessionStorage.getItem('activeUserId')
      };

      Servicecalls("" + this.ELNurl + "/Login/Logout", passobject, this.onLogOutSuccess.bind(this), this.onLogOutFailure.bind(this));

      $.session.remove("User");
      $.session.remove("Username");
      $.session.remove("name");
      $.session.remove("Usersite");
      $.session.remove("Usersitename");
      $.session.remove("usergroupname");
      $.session.remove("Token");
      $.session.remove("idletime");
    } else {
      $.session.remove("_OrderView");
      $.session.remove("User");
      $.session.remove("Username");
      $.session.remove("name");
      $.session.remove("Usersite");
      $.session.remove("Usersitename");
      $.session.remove("usergroupname");
      $.session.remove("Token");
      $.session.remove("idletime");
    }

    store.dispatch(replacestate(defalutreduxState));
    store.getState().Sheetview.stopDisabled = false;

    if (
      this.props.location.hash !== undefined &&
      this.props.location.hash.length > 0 &&
      isMultitenant === 0
    ) {
      let userdetails = this.props.location.hash.substring(
        1,
        this.props.location.hash.length
      );
      if (userdetails !== undefined && userdetails.split("$").length > 1) {
        this.validatelinklogin(userdetails);
      }
    }

    if (
      this.props.location.hash !== undefined &&
      this.props.location.hash.length > 0 &&
      isMultitenant === 1
    ) {
      let tenant = this.props.location.hash.substring(1, this.props.location.hash.length);

      let tenantid = tenant.replaceAll("%20", " ");
      let rtnobj = { tenantid: tenantid };
      this.setState({
        ServiceToUrl: "" + this.ELNurl + "/multitenant/Validatetenant",
        ServiceHeaderobject: rtnobj,
        ServiceMethodType: "POST",
        ServcieonSuccess: this.ontenantSuccess.bind(this),
        ServcieonFailure: (res) => { },
        ServcieProcessbar: true,
        ServiceTenant: "MAIN",
      });

    } else if (isMultitenant === 1) {
      sessionStorage.clear();
      this.setState({ CurrentView: 3, hashtenant: "" });

    }
    else if (isMultitenant === 2) {
      sessionStorage.clear();
      this.setState({ CurrentView: 5, hashtenant: "" });
    }
  }

  onLoadDomainSuccess(response) {
    let domain = response;

    domain = domain.sort((a, b) =>
      a.domaincode > b.domaincode ? 1 : b.domaincode > a.domaincode ? -1 : 0
    );
    console.log(domain);
    this.setState({
      DomainData: domain,
      DomainCode: domain[0].domaincode,
      DomainCategory: domain[0].categories,
    });
  }

  ontenantSuccess(response) {
    if (response !== undefined && response !== null) {
      let status = response.objResponse !== undefined && response.objResponse !== null ? response.objResponse.status : false;

      if (status) {
        sessionStorage.setItem("isenableparser", response.isenableparser);
        sessionStorage.setItem("isenablereport", isReportEnabled ? response.isenablereport : undefined);
        sessionStorage.setItem("tenantcode", response.id);
        sessionStorage.setItem("tenantid", response.name);
        sessionStorage.setItem("tenantdomain", response.tenantid);
        sessionStorage.setItem("loginfrom", response.loginfrom);
        sessionStorage.setItem("noofusers", response.noofusers);
        sessionStorage.setItem("packagetype", response.plantype);
        sessionStorage.setItem("licencetype", response.licencetype);
        sessionStorage.setItem('__lock', '1');

        this.sitefordomain = response.name;
        this.setState({ CurrentView: 0, hashtenant: response.name, currenttenant: response.name })
        this.onTenantvaidate(0, response.name);
      } else if (response.objResponse.information === "ID_ORGNOTEXIST") {
        this.props.history.push("/");
        sessionStorage.clear();
      }
    }
  }

  onDomainCodeChange(id, value, text) {
    let Domain = value.split("|||");
    if (value.indexOf("|||") > -1 && Domain.length >= 2) {
      this.setState({ DomainCode: Domain[0], DomainCategory: Domain[1] });
    }
  }

  onLogOutSuccess(res) {
    $.session.remove("User");
    $.session.remove("Username");
    $.session.remove("Usersite");
    $.session.remove("name");
    $.session.remove("Usersitename");
    $.session.remove("usergroupname");
    $.session.remove("Token");
    $.session.remove("idletime");
    store.dispatch(replacestate(defalutreduxState));
  }

  onLogOutFailure() { }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onLoginSuccess(response) {
    let loggeduser = response;
    let multiusergroup = response?.multiusergroupcode?.find((obj) => obj.defaultusergroup === 1);
    let lsusergroup = multiusergroup.lsusergroup;
    if (loggeduser.objResponse.status) {
      if (
        response.activeUserId !== undefined &&
        response.activeUserId.activeusercode !== null
      ) {
        sessionStorage.setItem("activeUserId", response.activeUserId.activeusercode);
      }

      // sessionStorage.setItem("LoginTime", new Date());
      let date = new Date();
      if (response.Logintime !== undefined) {
        date = convertUTCDateToLocalDate(new Date(response.Logintime));
      }
      sessionStorage.setItem("LoginTime", date !== undefined ? date : new Date());
      sessionStorage.setItem("User", loggeduser.usercode);
      sessionStorage.setItem("Username", loggeduser.username);
      sessionStorage.setItem("Userfullname", loggeduser.userfullname);
      sessionStorage.setItem("Usersite", loggeduser.lssitemaster.sitecode);
      sessionStorage.setItem("Usersitename", loggeduser.lssitemaster.sitename);
      sessionStorage.setItem(
        "usergroupname",
        lsusergroup.usergroupname
      );
      sessionStorage.setItem(
        "usergroupstatus",
        lsusergroup.usergroupstatus
      );
      sessionStorage.setItem("UserMail", loggeduser.emailid);
      sessionStorage.setItem("accouttype", response?.lssitemaster?.accouttype !== undefined && loggeduser?.lssitemaster?.accouttype !== null ? loggeduser?.lssitemaster?.accouttype : undefined);

      // if (loggeduser.idletimeshowcheck !== 0) {
      sessionStorage.setItem("idletime", loggeduser.idletime);
      // }

      let notification = {};
      notification["currentdate"] = GetutcDate(new Date());
      notification["usercode"] = $.session.get("User");
      notification["addedby"] = $.session.get("Username");
      notification["sitecode"] = $.session.get("Usersite");
      notification["Usersitename"] = $.session.get("Usersitename");

      Servicecalls("" + this.ELNurl + "/Login/Loginnotification", notification, () => { }, () => { });
      // let passObject = {};
      // Servicecalls("" + this.ELNurl + "/materialType/syncSamplestoType", passObject, () => { }, () => { });
      Servicecalls("" + this.ELNurl + "/Login/Resourcenotification", notification, () => { }, () => { });

      sessionStorage.setItem("unifieduserid", loggeduser.unifieduserid);
      sessionStorage.setItem("multiusergroups", lsusergroup.usergroupcode);
      sessionStorage.setItem(
        "userpasscodeencrypted",
        response.encryptedpassword
      );

      localStorage.setItem(
        "elnLoginSiteCode",
        loggeduser.lssitemaster.sitecode
      );
      localStorage.setItem(
        "elnLoginSiteName",
        loggeduser.lssitemaster.sitename
      );

      store.getState().Loggeduser = loggeduser;

      if (loggeduser.passwordexpirydate !== null) {
        let date1 = new Date();
        let date2 = new Date(loggeduser.passwordexpirydate);
        let no_of_days = new Date(date2) - new Date(date1);
        let expiryindays = no_of_days / (1000 * 3600 * 24);
        if (loggeduser.username !== "Administrator") {
          if ($.session.get("loggedfrom") !== "1") {
            if (
              Math.round(expiryindays) < 11 &&
              Math.round(expiryindays) !== 0
            ) {
              this.props.alert.error(
                this.props.t("Setup.Passwordpolicy.IDS_LBL_PWDEXPINDAYS", {
                  days: Math.round(expiryindays),
                })
              );
            }
          } else if (Math.round(expiryindays) === 0) {
            let hour_date2 = date2.getHours();
            let min_date2 = date2.getMinutes();
            let sec_date2 = date2.getSeconds();
            let date2_hour = hour_date2 + ":" + min_date2 + ":" + sec_date2;
            if ($.session.get("loggedfrom") !== "1") {
              this.props.alert.error(
                this.props.t("LoginView.IDS_PWDEXPINHOURS", {
                  hours: date2_hour,
                })
              );
            }
          }
        }
      }

      setTimeout(() => {
        this.redirecttohome();
      }, 10);

      let passobj = {
        username: loggeduser.username,
        lssitemaster: loggeduser.lssitemaster,
      };

      this.generatetokenforlink(passobj);
      getCurrentDateAndTimeOnBackend();

      const passTransObj = {
        silentAudit: Silentauditobject("success", "Login"),
        currentDate: GetutcDate(new Date()),
        sitecode: Number(sessionStorage.Usersite),
      };

      Servicecalls(
        "" + this.ELNurl + "/transaction/updateMaterialInventoryNotification",
        passTransObj,
        (response) => { },
        () => { }
      );

      Serviceuserworkflowdetails(
        "" +
        this.ELNurl +
        "/Instrument/Getuserworkflow",
        { usergroupcode: lsusergroup.usergroupcode }
      );

      Serviceprojectdetails(
        "" +
        this.ELNurl +
        "/Instrument/Getuserprojects",
        store.getState().Loggeduser
      );

      Serviceforusersettings(
        "" +
        this.ELNurl +
        "/User/getUserPrefrences",
        { usercode: loggeduser.usercode }
      );

      Serviceforserverdateformat(
        "" +
        this.ELNurl +
        "/Login/serverDateFormat",
        { usercode: loggeduser.usercode }
      );

      let objsilentaudit = onAuditHandler(
        "update",
        "Login",
        loggeduser.lsusergroup.usergroupname +
        " user was logged in successfully",
        "",
        "lsactiveuser"
      );

      if (objsilentaudit !== null) {
        let passObjDet = { objsilentaudit: objsilentaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    } else if (response.user.objResponse.information === "ID_NOTACTIVE") {
      this.props.alert.error(
        this.props.t("Login.IDS_MSG_NOTACTIVE", { param: "" })
      );

      let objsilentaudit = onAuditHandler(
        "update",
        "Login",
        "User : " +
        loggeduser.lsusergroup.usergroupname +
        " " +
        this.props.t("Login.IDS_MSG_NOTACTIVE", { param: "" }),
        "",
        "lsusermaster"
      );

      objsilentaudit.lssitemaster = loggeduser.lssitemaster.sitecode;
      if (objsilentaudit !== null) {
        let passObjDet = { objsilentaudit: objsilentaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    } else if (response.user.objResponse.information === "ID_RETIREDUSER") {
      this.props.alert.error(
        this.props.t("LoginView.ID_RETIREDUSER", { user: loggeduser.username })
      );

      let objsilentaudit = onAuditHandler(
        "update",
        "usermaster",
        this.props.t("LoginView.ID_RETIREDUSER", { user: loggeduser.username }),
        "",
        "lsusermaster"
      );
      objsilentaudit.lssitemaster = loggeduser.lssitemaster.sitecode;
      if (objsilentaudit !== null) {
        let passObjDet = { objsilentaudit: objsilentaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    } else if (response.user.objResponse.information === "IDS_LICENCERCHD") {
      this.props.alert.error(
        this.props.t("License reached,contact Adminstrator!", {})
      );

      let objsilentaudit = onAuditHandler(
        "update",
        "usermaster",
        this.props.t("License reached,contact Adminstrator!", {}),
        "",
        "lsusermaster"
      );
      // objsilentaudit.lssitemaster = loggeduser.lssitemaster.sitecode
      if (objsilentaudit !== null) {
        let passObjDet = { objsilentaudit: objsilentaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    } else if (
      response.user.objResponse.information === "IDS_SETCONCURRENTLICENCE"
    ) {
      this.props.alert.error("Set concurrent licence value");
    } else if (response.user.objResponse.information === "ID_GRPNOACT") {
      this.props.alert.error(
        this.props.t("Login.IDS_MSG_GRPNOACT", { param: "" })
      );

      let objsilentaudit = onAuditHandler(
        "update",
        "usermaster",
        this.props.t("Login.IDS_MSG_GRPNOACT", { param: "" }),
        "",
        "lsusermaster"
      );
      objsilentaudit.lssitemaster = loggeduser.lssitemaster.sitecode;
      if (objsilentaudit !== null) {
        let passObjDet = { objsilentaudit: objsilentaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    } else if (response.user.objResponse.information === "ID_INVALID") {
      this.props.alert.error(
        this.props.t("Login.IDS_MSG_INVALID", { param: "" })
      );
      this.setState({ Password: "" });
      let objsilentaudit = onAuditHandler(
        "login",
        "usermaster",
        this.props.t("Login.IDS_MSG_INVALID", { param: "" }),
        "",
        "lsusermaster"
      );
      objsilentaudit.lssitemaster = loggeduser.lssitemaster.sitecode;

      if (objsilentaudit !== null) {
        let passObjDet = { objsilentaudit: objsilentaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    } else if (response.user.objResponse.information === "IDS_MSG_NOTEXIST") {
      this.props.alert.error(
        this.props.t("Login.IDS_MSG_NOTEXIST", { param: "" })
      );

      let objsilentaudit = onAuditHandler(
        "update",
        "usermaster",
        this.props.t("Login.IDS_MSG_NOTEXIST", { param: "" }),
        "",
        "lsusermaster"
      );

      if (objsilentaudit !== null) {
        let passObjDet = { objsilentaudit: objsilentaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    } else if (response.user.objResponse.information === "ID_LOCKED") {
      this.props.alert.error(
        this.props.t("Login.IDS_MSG_LOCKED", { param: "" })
      );
      let objsilaudit = onAuditHandler(
        "login",
        "usermaster",
        this.props.t(
          "Login.IDS_AUDIT_LOCKED",
          { user: $.session.get("Username") },
          "lsusermaster"
        )
      );
      objsilaudit.lssitemaster = response.user.lssitemaster.sitecode;
      if (objsilaudit !== null) {
        let passObjDet = { objsilentaudit: objsilaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    } else if (response.user.objResponse.information === "ID_EXPIRY") {
      this.props.alert.error(
        this.props.t("Login.IDS_MSG_EXPIRY", { param: "" })
      );
      let site = response.user.lssitemaster.sitecode;
      if (this.props.onforgot !== undefined) {
        this.props.onforgot(
          site,
          this.state.UserName,
          response.user.lssitemaster,
          loggeduser
        );
      }
      if (this.props.isswitchsite) {
        this.setState({ loginClicked: true });
        this.props.alert.error(
          this.props.t("Header.IDS_NEWPASSGENARATE", {
            user: this.state.UserName,
          })
        );
      }

      let objsilentaudit = onAuditHandler(
        "update",
        "usermaster",
        "User : " + this.props.t("Login.IDS_MSG_EXPIRY", { param: "" }),
        "",
        "lsusermaster"
      );
      objsilentaudit.lssitemaster = response.user.lssitemaster.sitecode;
      if (objsilentaudit !== null) {
        let passObjDet = { objsilentaudit: objsilentaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    } else if (response.user.objResponse.information === "ID_SITEVALID") {
      this.props.alert.error(
        this.props.t("Login.IDS_MSG_SITEVALID", { param: "" })
      );

      let objsilentaudit = onAuditHandler(
        "update",
        "usermaster",
        "User : " + this.props.t("Login.IDS_MSG_SITEVALID", { param: "" }),
        "",
        "lsusermaster"
      );

      if (objsilentaudit !== null) {
        let passObjDet = { objsilentaudit: objsilentaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    }

    this.setState({ loginClicked: false });
  }

  onUserRightsUpdateSuccess(res) {
    store.dispatch(updatecontrolrights(res));
  }

  onLinkLoginFailure() { }

  async validatelinklogin(userdetails) {
    let user = {
      username: CF_decrypt(userdetails.split("$")[0]).replaceAll('\"', ''),
      password: userdetails.split("$")[1],
    };

    Servicecalls(
      "" + this.ELNurl + "/Login/LinkLogin",
      user,
      this.onLoginSuccess.bind(this),
      this.onLinkLoginFailure.bind(this)
    );

    // request
    //   .post("" + this.ELNurl + "/Login/LinkLogin")
    //   .send(await gzip(JSON.stringify(user)))
    //   .set({
    //     'Authorization': $.session.get("Token"), 'X-TenantID': $.session.get("tenantid"),
    //     Accept: 'application/json', "Content-Type": 'application/json',
    //     "Content-Encoding": 'gzip'
    //   })
    //   .then((resDom) => {
    //     let loggeduser = JSON.parse(resDom.text);
    //     $.session.set("User", loggeduser.usercode);
    //     $.session.set("Username", loggeduser.username);
    //     $.session.set("Usersite", loggeduser.lssitemaster.sitecode);
    //     $.session.set("Usersitename", loggeduser.lssitemaster.sitename);
    //     $.session.set("usergroupname", loggeduser.lsusergroup.usergroupname);
    //     this.redirecttohome();
    //     let passobject = {
    //       username: loggeduser.username,
    //       lssitemaster: loggeduser.lssitemaster
    //     }

    //     this.generatetokenforlink(passobject);

    //   })
    //   .catch((error) => { });
  }

  onLinkSuccess(res) {
    let response1 = res;
    if (response1 !== null) {
      let token = "Bearer " + response1.token;
      $.session.set("Token", token);
    }

  }

  onLinkFailure() { }
  async generatetokenforlink(passobject) {
    Servicecalls(
      "" +
      this.ELNurl +
      "/Login/limsloginusertokengenarate",
      passobject,
      this.onLinkSuccess.bind(this),
      this.onLinkFailure.bind(this)
    );

    // request
    //   .post("" + this.ELNurl + "/Login/limsloginusertokengenarate")
    //   .send(await gzip(JSON.stringify(passobject)))
    //   .set({
    //     'Authorization': $.session.get("Token"), 'X-TenantID': $.session.get("tenantid"),
    //     Accept: 'application/json', "Content-Type": 'application/json',
    //     "Content-Encoding": 'gzip'
    //   })
    //   .then(async (res) => {
    //     let response1 = JSON.parse(res.text);
    //     if (response1 !== null) {
    //       let token = "Bearer " + response1.token;
    //       $.session.set("Token", token);
    //     }
    //   })
    //   .catch((error) => { });
  }

  redirecttohome() {
    this.props.history.push("/Home");
    this.props.alert.success(this.props.t("Login.IDS_MSG_LOGIN"));
    // store.dispatch(SheetandProtocolOrders(undefined));
  }
  forgotpass(sitecodeval, usernameval, siteobjval, response) {
    this.setState({
      CurrentView: 1,
      sitecode: sitecodeval,
      username: usernameval,
      siteobj: siteobjval,
      passwordstatus: response.passwordstatus,
      Userobj: response,
    });
  }
  Cancel(usernameval, iscreated) {
    if (usernameval === undefined) {
      this.setState({
        sitecode: "",
        siteobj: "",
        iscreated: false
      })
    }
    this.setState({
      CurrentView: 0,
      username: usernameval,
      iscreated: iscreated,
      siteobj: "",
    });
  }
  NewRegistration() {
    this.setState({ CurrentView: 2 });
  }
  CF_DeviceChecking() {
    var ua = navigator.userAgent;
    var checker = {
      iphone: ua.match(/(iPhone|iPod|iPad)/),
      blackberry: ua.match(/BlackBerry/),
      android: ua.match(/Android/),
    };
    return checker;
  }

  onTenantvaidate(value, selectedtenant) {
    console.log("validate");
    let newSite = { sitecode: 1 };
    Servicecalls("" + this.ELNurl + "/Login/LoadDomain", newSite, (response) => {
      let domain = response;
      console.log(domain);
      domain = domain.sort((a, b) =>
        a.domaincode > b.domaincode ? 1 : b.domaincode > a.domaincode ? -1 : 0
      );

      this.setState({
        DomainData: domain,
        DomainCode: domain[0].domaincode,
        DomainCategory: domain[0].categories,
      });
    }, (response) => { });
    this.setState({ CurrentView: value, currenttenant: selectedtenant });
  }

  onTenantRegister(value) {
    console.log("register");
    this.setState({ CurrentView: value });
  }

  onbackclick(value) {
    this.props.history.push("/");
    this.setState({ CurrentView: 3, hashtenant: "" });
    sessionStorage.clear();
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }));
  };

  autenticationapponazure = () => {
    this.redirecttohome();
    $.session.set("User", 1);
    $.session.set("Username", "Administrator");
    $.session.set("Usersite", 1);
    $.session.set("Usersitename", "Default");
    $.session.set("usergroupname", "Administrator");
  };

  onLangauageCodeChange(id, value, text) {
    setLanguage(value);
    localStorage.setItem("ElnLang", value);
    setTimeout(() => {
      this.setState({
        LanguageCode: value,
        LanguageData: [
          {
            sLanguageName: this.props.t("Login.IDS_LBL_ENGLISH", { param: "" }),
            sLanguageCode: "en",
          },
          {
            sLanguageName: this.props.t("Login.IDS_LBL_KOREAN", { param: "" }),
            sLanguageCode: "ko",
          },
          {
            sLanguageName: this.props.t("Login.IDS_LBL_FRENCH", { param: "" }),
            sLanguageCode: "fr",
          },
          {
            sLanguageName: this.props.t("Login.IDS_LBL_GERMAN", { param: "" }),
            sLanguageCode: "de",
          },
        ],
      });
    }, 100);

  }



  render() {
    let ViewContent;
    //const { isDropdownOpen } = this.state;
    const carouselOptions = {
      loop: true,
      margin: 10,
      slideSpeed: 300,
      dots: true,
      autoPlay: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 1,
        },
        1200: {
          items: 1,
        },
      },
    };

    const items = [
      {
        type: 1, name: this.props.t("Login.IDS_LBL_OWLHEADERONE", { param: "" }), imageUrl: "images/creativ_1.svg",
        description: this.props.t("Login.IDS_LBL_OWLDESCRIPTIONONE", { param: "" })
      },
      {
        type: 2, name: this.props.t("Login.IDS_LBL_OWLHEADERTWO", { param: "" }), imageUrl: "images/creativ_2.svg",
        description: this.props.t("Login.IDS_LBL_OWLDESCRIPTIONTWO", { param: "" })
      },
      {
        type: 3, name: this.props.t("Login.IDS_LBL_OWLHEADERTHREE", { param: "" }), imageUrl: "images/creativ_3.svg",
        description: this.props.t("Login.IDS_LBL_OWLDESCRIPTIONTHREE", { param: "" })
      },
    ];

    if (this.state.CurrentView === 0) {
      ViewContent = (
        <Suspense fallback={<div></div>}>
          <LoginView
            OnSuccess={this.redirecttohome.bind(this)}
            onforgot={this.forgotpass.bind(this)}
            onnewregister={this.NewRegistration.bind(this)}
            username={this.state.username}
            siteobj={this.state.siteobj}
            onbackclick={this.onbackclick.bind(this)}
            hashtenant={this?.state?.hashtenant ? this?.state?.hashtenant : this?.state?.currenttenant}
            selectedtenant={this.state.currenttenant}
            isswitchsite={this.state.username !== "" ? true : false}
            iscreated={this.state.iscreated}
          />
          {/* <Azureredirect /> */}
        </Suspense>
      );
    } else if (this.state.CurrentView === 1) {
      ViewContent = (
        <Suspense fallback={<div></div>}>
          <Newpwdgenetration
            oncancel={this.Cancel.bind(this)}
            sitecode={this.state.sitecode}
            username={this.state.username}
            siteobj={this.state.siteobj}
            passwordstatus={this.state.passwordstatus}
            Userobj={this.state.Userobj}
          />
        </Suspense>
      );
    } else if (this.state.CurrentView === 3) {
      ViewContent = (
        <Suspense fallback={<div></div>}>
          <Tenantselection ontenantvalidate={this.onTenantvaidate.bind(this)} />
        </Suspense>
      );
    } else if (this.state.CurrentView === 4) {
      ViewContent = (
        <Suspense fallback={<div></div>}>
          <TenantRegistration
            ontenantRegister={this.onTenantRegister.bind(this)}
          />
        </Suspense>
      );
    } else if (this.state.CurrentView === 5) {
      ViewContent = (<Suspense fallback={<div></div>}><FreeUserLogin
        OnSuccess={this.redirecttohome.bind(this)}
        alert={this.props.alert}
        t={this.props.t} /></Suspense>)
    }
    else {
      ViewContent = (
        <Suspense fallback={<div></div>}>
          <div></div>
        </Suspense>
      );
    }
    //<Link to="/Home">Home</Link>
    /*if (this.state.redirect) {
        return <Redirect to='/Home' />;
      }*/

    // <button id="login_changepwdbtn" type="button" ctrl_type='button' className="btn col-md-12 changePasswordbtn">Change Password</button>

    return (
      <div className="login-wrapper" id="loginPage">
        <Service
          Tourl={this.state.ServiceToUrl}
          MethodType={this.state.ServiceMethodType}
          onSuccess={this.state.ServcieonSuccess}
          onFailure={this.state.ServcieonFailure}
          Headerobject={this.state.ServiceHeaderobject}
          onReseturl={() => {
            this.setState({ ServiceToUrl: "" });
          }}
          ServiceTenant={this.state.ServiceTenant}
          Needprogress={this.state.ServcieProcessbar}
          outerloader={true}
        ></Service>

        <div className="container-fluid px-0">
          <div className="row no-gutters">
            <div className="col-md-6 col-12">
              <div className={`login-panel h-100 ${isMultitenant === 2 ? "freeuser" : ""}`}>
                <div className="card h-100">
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-1">
                      <span className="primary-logo">
                        {isMultitenant === 2 ? <img
                          src="images/eln_lite_logo.svg"
                          alt="eln-logo"
                        /> :
                          <img
                            src="images/Logilab_ELN_Logo.svg"
                            alt="eln-logo"
                          />}
                        {isMultitenant === 2 ? <span></span> : <span className="version-txt">
                          {this.props.t("Login.IDS_LBL_VERSION", {
                            param: "",
                          }) + releaseVersion}
                        </span>}
                      </span>{" "}

                    </div>
                    <h1 className="login-primary-header">
                      {this.props.t("Login.IDS_LBL_WELCOMETOLOGILAB", {
                        param: "",
                      })}{" "}
                      <span className="login-secondary-header">ELN</span>{" "}
                    </h1>
                    <p className="header-help-txt">
                      {this.props.t("Login.IDS_LBL_WEMAKE", {
                        param: "",
                      })}
                    </p>
                    {ViewContent}
                  </div>
                  <div className="login-footer lfWeb">
                    <span className="primary-logo bottom">
                      <img
                        src="images/Agaram_Technologies_Logo.svg"
                        alt="Agaram_eln-logo"
                      />
                    </span>
                    {isMultitenant === 2 ? <div className="card footercard">
                      <ul className="list-inline mb-0 footerlist">
                        {/* <li className="list-inline-item float-left">
                          <div className="dropdown ">
                            <button
                              className="dropdown-toggle hidden-arrow free-dropdown"
                              type="button"
                              id="dropdownMenu1"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              onClick={this.toggleDropdown}
                            >
                              <i className="countryicon_bule"></i>
                              Select
                            </button>
                            <ul
                              className={`dropdown-menu`}
                              aria-labelledby="dropdownMenu1"
                            >
                              <li><a className="dropdown-item" href="#"> India</a> </li>
                              <li><a className="dropdown-item" href="#"> UK</a> </li>
                            </ul>
                          </div>
                        </li> */
                          <li className="list-inline-item float-right ml-3 mt-1"><a href="https://www.logilabeln.com/pricing" target="_blank" rel="noopener noreferrer" className="btn btn-primary-blue">Compare Plans</a></li>
                        }
                        <li className="list-inline-item float-right">
                          <div className={`language_bules ${isMultitenant === 2 ? "multilanguage" : ""}`} title="Language">
                            <Suspense fallback={<div></div>}>
                              <SelectBox
                                Keyvalue="idLanguage"
                                selClsname={
                                  "form-control form-control-sm free-dropdown " +
                                  this.state.LanguageCodeValidcls
                                }
                                Datasource={this.state.LanguageData}
                                ValueMember="sLanguageCode"
                                DisplayMember="sLanguageName"
                                valuechange={this.onLangauageCodeChange.bind(this)}
                              //value={this.props.getLanguage()}
                              />
                            </Suspense>

                          </div>
                        </li>
                      </ul>
                    </div> : <div className="card footercard">
                      <ul className="list-inline mb-0 footerlist">
                       {this.state.CurrentView === 3 ? ("") : (<li className="list-inline-item float-left">
                          <div className="domain-icon" title="Domain">

                            <Suspense fallback={<div></div>}>
                              <SelectBox
                                Keyvalue="idDomain"
                                selClsname={
                                  "form-control form-control-sm free-dropdown" +
                                  this.state.DomainCodeValidcls
                                }
                                Datasource={this.state.DomainData}
                                ValueMember="domaincode"
                                DisplayMember="domainname"
                                AttributeMember="categories"
                                valuechange={this.onDomainCodeChange.bind(this)}
                              >
                              </SelectBox>
                            </Suspense>
                          </div>
                        </li> )  }
                        <li className="list-inline-item float-right">
                          <div className="language_bules" title="Language">
                            <Suspense fallback={<div></div>}>
                              <SelectBox
                                Keyvalue="idLanguage"
                                selClsname={
                                  "form-control form-control-sm free-dropdown " +
                                  this.state.LanguageCodeValidcls
                                }
                                Datasource={this.state.LanguageData}
                                ValueMember="sLanguageCode"
                                DisplayMember="sLanguageName"
                                valuechange={this.onLangauageCodeChange.bind(this)}
                                value={getLanguage()}
                              />
                            </Suspense>
                          </div>
                        </li>
                      </ul>
                      {/* <p>
                        {this.props.t("Footer.IDS_LBL_COPYRIGHT", { param: "" })}
                      </p>
                      <ul className="btm-foot-txt">
                        <li>
                          <a
                            href="https://www.agaramtech.com/product/logilab-eln-software/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {this.props.t("Footer.IDS_LBL_ABOUT", { param: "" })}
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.agaramtech.com/terms-and-conditions/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {this.props.t("Footer.IDS_LBL_TERM_COND", { param: "" })}
                          </a>
                        </li>
                      </ul> */}
                    </div>}
                  </div>
                </div>
              </div>
            </div>
            <div className={` col-md-6 col-12 info-bottom-card  card_bg ${isMultitenant === 2 ? "owlmargin" : ""}`}>
              <div className="info-panel">
                <div className="card vh-100-min">
                  <div className="card-body">
                    <div className='owlcorouse_design'>
                      <div className="owlcorouse-bg">
                        <Suspense fallback={<div></div>}>
                          <OwlCarousel className="brand-carousel section-padding owl-carousel" {...carouselOptions} items={1} margin={8} autoplay={true} >

                            {items.map((item, index) => (
                              <div className='item' key={index}>
                                <h4>{item.name}</h4>
                                <span className="owlimages"><img src={item.imageUrl} alt={item.name} /></span>
                                <p>{item.description}</p>
                              </div>
                            ))}
                          </OwlCarousel>
                        </Suspense>
                      </div>
                    </div>

                  </div>
                  {/* <div className="card-body">
                    <h2 className="page-header">
                      {" "}
                      {this.props.t("Login.IDS_LBL_HOWWE", {
                        param: "",
                      })}
                    </h2>
                    <div className="media mb-3">
                      <img
                        src="images/spreadsheet-templates.svg"
                        className="mr-4"
                        alt="method-execution"
                        width="42"
                        height="42"
                      />
                      <div className="media-body">
                        <h5 className="mt-0 media-heading">
                          {this.props.t("Login.IDS_LBL_ELNTEMPLATES", {
                            param: "",
                          })}
                        </h5>
                        <p>
                          {this.props.t("Login.IDS_LBL_USE", {
                            param: "",
                          })}
                        </p>
                      </div>
                    </div>
                    <div className="media mb-4">
                      <img
                        src="images/instrument-data.svg"
                        className="mr-4"
                        alt="method-execution"
                        width="42"
                        height="42"
                      />
                      <div className="media-body">
                        <h5 className="mt-0 media-heading">
                          {this.props.t("Login.IDS_LBL_COLLABORATE", {
                            param: "",
                          })}
                        </h5>
                        <p>
                          {this.props.t("Login.IDS_LBL_AUTOMATICALLY", {
                            param: "",
                          })}
                        </p>
                      </div>
                    </div>
                    <div className="media mb-4">
                      <img
                        src="images/method-execution.svg"
                        className="mr-4"
                        alt="method-execution"
                        width="42"
                        height="42"
                      />
                      <div className="media-body">
                        <h5 className="mt-0 media-heading">
                          {this.props.t("Login.IDS_LBL_METHODEXECUTION", {
                            param: "",
                          })}
                        </h5>
                        <p>
                          {this.props.t("Login.IDS_LBL_ELECTRONICALLY", {
                            param: "",
                          })}
                        </p>
                      </div>
                    </div>
                    <div className="media mb-4">
                      <img
                        src="images/workflows.svg"
                        className="mr-4"
                        alt="method-execution"
                        width="42"
                        height="42"
                      />
                      <div className="media-body">
                        <h5 className="mt-0 media-heading">
                          {this.props.t("Login.IDS_LBL_PROTOCOLBASEDNOTE", {
                            param: "",
                          })}
                        </h5>
                        <p>
                          {this.props.t("Login.IDS_LBL_PNOTEBOOK", {
                            param: "",
                          })}
                        </p>
                      </div>
                    </div>
                    <div className="media mb-4">
                      <img
                        src="images/reports.svg"
                        className="mr-4"
                        alt="method-execution"
                        width="42"
                        height="42"
                      />
                      <div className="media-body">
                        <h5 className="mt-0 media-heading">
                          {this.props.t("Login.IDS_LBL_PROFESSIONNALREPORTS", {
                            param: "",
                          })}
                        </h5>
                        <p>
                          {this.props.t("Login.IDS_LBL_PREPORT", {
                            param: "",
                          })}
                        </p>
                      </div>
                    </div>
                    <div className="media mb-4">
                      <img
                        src="images/workflowssteps.svg"
                        className="mr-4"
                        alt="method-execution"
                        width="42"
                        height="42"
                      />
                      <div className="media-body">
                        <h5 className="mt-0 media-heading">
                          {this.props.t("Login.IDS_LBL_WORKFLOWS", {
                            param: "",
                          })}
                        </h5>
                        <p>
                          {this.props.t("Login.IDS_LBL_CONFIGURE", {
                            param: "",
                          })}
                        </p>
                      </div>
                    </div>
                  </div> */}
                  <div className="card-img-bottom">
                    {/* <div className="info-bottom-card"></div> */}
                  </div>



                </div>
              </div>

              <div className='register-footer text-center'>
                <div className="login-footer lfWeb">
                  <div className='d-flex w-100'>
                    <p className=''>{this.props.t("Header.IDS_LBL_COPYRIGHT", { param: "" })}</p>
                    <ul className='list-inline mb-0'>
                      <li className='list-inline-item'>
                        <a href="https://www.agaramtech.com/about-us"
                          target="_blank"
                          rel="noopener noreferrer"
                        >{this.props.t("Header.IDS_LBL_ABOUT", { param: "" })}</a>|
                      </li>
                      <li className='list-inline-item'> <a
                        href="https://www.agaramtech.com/terms-and-conditions/"
                        target="_blank"
                        rel="noopener noreferrer">
                       {this.props.t("Header.IDS_LBL_TERM_COND", { param: "" })}
                      </a>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>

            <div className="col-12 lf_mobileView">
              <div className="login-footer">
                <span className="primary-logo bottom">
                  <img
                    src="images/Agaram_Technologies_Logo.svg"
                    alt="Agaram_eln-logo"
                  />
                </span>
                <div>
                  <p>
                    {this.props.t("Footer.IDS_LBL_COPYRIGHT", { param: "" })}
                  </p>
                  <ul className="btm-foot-txt">
                    <li>
                      <a
                        href="https://www.agaramtech.com/about-us"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {this.props.t("Header.IDS_LBL_ABOUT", { param: "" })}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.agaramtech.com/terms-and-conditions/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {this.props.t("Header.IDS_LBL_TERM_COND", { param: "" })}
                      </a>
                    </li>
                  </ul>
                </div>
              </div> </div>


          </div>
        </div>
      </div>
    );
  }
}
export default withAlert()(withTranslation(Login));
